<template>
    <div class="marketplace-page">
        <div class="search">
                <div class="search-input">
                    <div class="input-wrapper">
                        <form onsubmit="return false;" autocomplete="off">
                            <input type="text"
                                :maxlength="60"
                                :placeholder="lbl.reward.search_product_placeholder"
                                v-model="searchQuery"/>
                        </form>
                    </div>
                </div>
                <div class="icon-wrapper">
                    <div class="icon theme-bg-color" @click="clickSearch()"></div>
                </div>
            </div>
        <div class="category">
            <CategorySlider
                :apiConfig="categoryConfig"
                @clickCategory="clickCategory" @cateError="cateError"></CategorySlider>
        </div>
        <div class="list-product">
            <CampaignList
                :userType="userType"
                :mainType="'catalogonline'"
                :initListConfig="listConfig"
                :initFilterConfig="filterConfig"
                :busEvent="busEvent"></CampaignList>
        </div>

        <!-- <div id="cart_icon">
            <div id="cart_icon_wrapper"
                :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}"
                @click="clickCart()">
                <div id="cart_count">{{cartAmount}}</div>
                <img class="img-fluid" src="../../../assets/icon/icon_cart.png" />
            </div>
        </div> -->
        <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
</template>
<script>
import Vue from 'vue';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//helper
import Account from '@/helper/AccountHelper.js';
//component
import CategorySlider from '../component/CategorySlider.vue';
import CampaignList from '../component/CampaignList.vue';
//core
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";

import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";

import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";

export default {
    name: "ProductList",
    mixins: [
        AccountMixin,
        LocaleMixin
    ],
    components: {
        ModalMaster,
        CampaignList,
        CategorySlider
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            //campaign
            isLoaded: false,
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),
            //bus
            busEvent: new Vue(),
            //product
            searchedQuery:'',
            searchQuery: '',
            listConfig: {},
            filterConfig: {},
            categoryConfig: {},
            categoryActive: 0,

            trackingService: new TrackingService(this),
            trackingScreenName: 'privilege_page_list',
        };
    },
    created: function() {
        //modal
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setAlertModal(this.alertModal);
        //error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        //this.initialProductConfig();

        this.initialCategoryConfig();
        let categoryFromLanding = Account.getCacheCustom('category');
        if(categoryFromLanding){
            this.clickCategory(categoryFromLanding)
        }

        this.trackingService.screenName(this.trackingScreenName);
    },
    methods: {
        //method
        initialProductConfig: function(category) {
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(Vue.bzbsConfig.mainConfig.marketplace)
                .setTop(25)
                .create();
            this.listConfig = listConfig;
            this.searchQuery = this.searchedQuery
            if(category){
                this.listConfig.strCatId = category;
            }

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
            if (this.searchQuery) {
                this.filterConfig.strSearch = this.searchQuery;
            }
        },
        initialCategoryConfig: function(){
            var categoryConfig = new CategoryConfigBuilder()
                .setConfig(Vue.bzbsConfig.mainConfig.menu_marketplace)
                .create();
            this.categoryConfig = categoryConfig;
        },
        //event
        clickCategory: function (data) {
            if (data) {
                var trackingEventCategory = 'privilege_page_list'
                var eventName = 'click_category_cpf'
                var tracking_label = data.id + '|' + data.name
                this.trackingService.event(trackingEventCategory, eventName, tracking_label, null)

                this.searchQuery = '';
                if(data.id){
                    this.categoryActive = data.id;
                    this.initialProductConfig(this.categoryActive);
                }else{
                    this.categoryActive = 0;
                    this.initialProductConfig();
                }

                this.busEvent.$emit("reInitList",{listConfig: this.listConfig, filterConfig: this.filterConfig});
            }
        },
        clickSearch: function(){
            this.searchedQuery = this.searchQuery
            this.initialProductConfig(this.categoryActive? this.categoryActive : null);
            this.busEvent.$emit("reInitList",{listConfig: this.listConfig, filterConfig: this.filterConfig});
        },
        clickBack: function () {
            this.$router.push('/');
        },
        clearTextSearch: function(){
            if (!this.searchQuery) {
                this.initialProductConfig();
                this.busEvent.$emit("reInitList",{listConfig: this.listConfig, filterConfig: this.filterConfig});
            }
        },
        cateError: function(error) {
            this.errorResponse(error, this.errorHandler);
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    @import "./MarketPlace.scss";
</style>
